import { render, staticRenderFns } from "./Wysiwyg.vue?vue&type=template&id=3aac3bdb&scoped=true&"
import script from "./Wysiwyg.vue?vue&type=script&lang=js&"
export * from "./Wysiwyg.vue?vue&type=script&lang=js&"
import style0 from "./Wysiwyg.vue?vue&type=style&index=0&id=3aac3bdb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aac3bdb",
  null
  
)

export default component.exports